module.exports = __webpack_public_path__ + "img/9.85687d9d.png";